import { BrowserRouter, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import AppRouter from "./router/AppRouter";

import "./App.css";

/* ---------------- LAYOUT CONTROL ---------------- */

function AppLayout() {

  const location =
    useLocation();

  /* Hide Navbar/Footer
     on Login + Signup pages */

  const hideLayout =
    location.pathname === "/login" ||
    location.pathname === "/signup";

  return (

    <>
      {!hideLayout && <Navbar />}

      <AppRouter />

      {!hideLayout && <Footer />}
    </>

  );

}

function App() {

  return (

    <BrowserRouter>

      <AppLayout />

    </BrowserRouter>

  );

}

export default App;